<div
  class="munily-title-preview"
  [class.munily-title-preview--large]="size === 'large'"
  [class.munily-title-preview--medium]="size === 'medium'"
  [class.munily-title-preview--small]="size === 'small'"
>
  <span class="munily-title-preview__text">{{ value }}</span>
  <common-icon-button
    *ngIf="showEditIcon"
    variant="plain"
    icon="edit"
    iconSet="material-icons-outlined"
    ariaLabel="Editar"
    class="munily-title-preview__edit-btn"
    (output)="onEdit()"
  ></common-icon-button>
</div>
